var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinWinnerTrophy2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 35,
    viewBox: "0 0 45 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.8745 7.60734C39.9387 5.34346 40.7029 11.8467 39.0807 14.5072C37.5234 17.0739 32.563 16.872 30.5515 17.319C28.5471 17.7588 29.8593 20.3688 29.8593 20.3688L42.1521 16.4106L43.5941 8.17693L39.1889 6.21585C39.1889 6.21585 37.4873 6.56913 36.8745 7.60734Z",
    fill: "url(#paint0_linear_2390_49698)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.97093 7.60734C4.90675 5.34346 4.1425 11.8467 5.75751 14.5072C7.31483 17.0739 12.2752 16.872 14.2867 17.319C16.2911 17.7588 14.9789 20.3688 14.9789 20.3688L2.68611 16.4106L1.24414 8.17693L5.64936 6.21585C5.64936 6.21585 7.35088 6.56913 7.96372 7.60734H7.97093Z",
    fill: "url(#paint1_linear_2390_49698)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2426 7.28277C34.2426 7.28277 36.456 5.4803 41.6831 5.61008C46.903 5.73986 44.2715 14.5287 42.2095 17.4126C40.2268 20.1812 33.3125 18.9627 32.0363 19.6837C30.7674 20.3975 31.8417 22.0629 31.3226 22.3513C30.8035 22.6397 29.1885 20.9382 29.5706 19.4818C29.9671 17.9966 37.2491 17.153 39.8446 14.781C42.5339 12.3224 41.6831 7.47022 39.3111 7.15298C36.5497 6.78528 36.2325 8.22726 36.0594 9.86389C35.8864 11.4645 33.2548 11.8754 33.2548 11.8754L34.2498 7.27556L34.2426 7.28277Z",
    fill: "url(#paint2_linear_2390_49698)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7529 22.3731C13.6664 22.3875 13.6015 22.3875 13.5799 22.3875C13.5799 22.3875 13.515 22.3731 13.4861 22.3586C12.9598 22.063 14.0413 20.4048 12.7724 19.691C11.4962 18.97 4.58199 20.1885 2.59928 17.4199C0.530058 14.536 -2.09432 5.74718 3.12561 5.6174C8.35274 5.48762 10.5734 7.28287 10.5734 7.28287L11.5683 11.89C11.5683 11.89 8.92953 11.479 8.76371 9.87842C8.59067 8.24178 8.27343 6.79981 5.51206 7.16751C3.13282 7.48474 2.28206 12.3298 4.97854 14.7883C7.57408 17.1604 14.856 18.0039 15.2526 19.4891C15.267 19.554 15.2814 19.6189 15.2958 19.6838C15.4689 20.8878 14.4018 22.1928 13.7746 22.3731H13.7529Z",
    fill: "url(#paint3_linear_2390_49698)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4244 20.1885C30.7755 19.1863 35.534 16.9945 38.2305 16.6052C40.9414 16.2158 41.7128 17.4127 41.6912 17.7011C41.6696 17.9895 40.7395 18.9916 37.4446 19.2872C34.1641 19.5828 32.4626 19.0998 31.4244 20.1885Z",
    fill: "#FF4D74"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32452 18.9773C1.96473 17.4848 8.62662 17.1388 11.4457 17.8958C14.2287 18.6456 13.998 20.3183 13.6735 20.3688C13.3491 20.412 13.5365 19.6406 12.3541 19.5541C11.1645 19.4603 6.54299 19.381 5.33173 18.9845L5.32452 18.9773Z",
    fill: "#FF4D74"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.30859 6.21584C3.65179 4.19709 10.1551 5.0118 10.1551 5.0118L10.5588 7.28289C10.5588 7.28289 3.96181 4.56479 1.30859 6.21584Z",
    fill: "url(#paint4_linear_2390_49698)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4907 4.39171C35.4907 4.39171 41.6983 4.18262 43.0898 5.95624C43.0898 5.95624 40.4798 4.63684 34.6543 7.01609L35.4907 4.39891V4.39171Z",
    fill: "url(#paint5_linear_2390_49698)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4907 4.7955C35.4907 4.7955 34.1568 10.4408 32.8014 14.4278C32.7869 14.4711 32.7653 14.5216 32.7509 14.5792C32.7365 14.6153 32.7221 14.6441 32.7148 14.6874C32.2534 16.0212 31.792 17.146 31.3883 17.7732C29.8165 20.1957 23.9621 22.748 23.2411 27.2397C23.0609 28.3428 23.2916 29.1864 23.7386 29.8353C24.9859 31.6666 27.9275 31.991 28.4034 32.3155C28.4178 32.3299 28.4322 32.3371 28.4466 32.3515C29.0595 32.8346 29.6363 34.2982 29.6363 34.2982C29.6363 34.2982 26.4207 34.7884 22.3543 34.7884C18.288 34.7884 15.1156 34.2982 15.1156 34.2982C15.1156 34.2982 15.7213 32.7625 16.3485 32.3155C16.8244 31.9838 19.939 31.6522 21.1863 29.7488C21.6117 29.1071 21.8208 28.2924 21.655 27.2325C20.9412 22.7408 14.9282 20.1813 13.3564 17.766C12.4408 16.3601 11.554 12.5461 10.9412 9.45305C10.4581 7.01613 10.1553 5.02621 10.1553 5.02621L22.448 6.98729L35.4834 4.7955H35.4907Z",
    fill: "url(#paint6_linear_2390_49698)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4722 3.8726C13.3201 0.714693 27.7037 -1.20313 34.4305 3.20208C42.0369 8.17687 6.05982 8.76808 10.4722 3.8726Z",
    fill: "url(#paint7_linear_2390_49698)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8616 4.31236C16.385 6.49695 29.6006 6.49694 32.2106 4.28352C33.9842 2.78387 28.3605 1.49332 22.7729 1.551C17.416 1.60146 12.2754 2.93529 13.8616 4.31236Z",
    fill: "url(#paint8_linear_2390_49698)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7151 14.6801C32.2537 16.0139 31.7922 17.1386 31.3885 17.7659C29.8168 20.1884 23.9624 22.7407 23.2414 27.2324C23.0611 28.3355 23.2919 29.1791 23.7389 29.8279C22.4267 31.205 21.7633 30.8085 21.1866 29.7414C21.6119 29.0997 21.821 28.285 21.6552 27.2252C20.9414 22.7335 14.9284 20.174 13.3567 17.7587C12.441 16.3528 11.5542 12.5388 10.9414 9.44574L10.9991 9.30875C10.9991 9.30875 12.0373 18.2994 19.1101 20.3686C26.1037 22.4162 31.6048 17.7082 32.7079 14.6729L32.7151 14.6801Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5264 19.2657C15.8148 18.6385 19.0231 21.2268 21.8278 22.0559C24.6324 22.8851 22.3685 24.7957 21.3303 24.5001C20.2921 24.2045 16.1176 19.8858 15.5336 19.2657H15.5264Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6368 34.2909C29.6368 34.2909 26.4212 34.7812 22.3549 34.7812C18.2885 34.7812 15.1162 34.2909 15.1162 34.2909C15.1162 34.2909 15.7219 32.7552 16.3491 32.3082C16.0319 33.6709 26.6231 32.6255 28.4544 32.3443C29.0672 32.8273 29.644 34.2909 29.644 34.2909H29.6368Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8817 34.7597C22.0432 34.4352 21.7836 33.4691 22.8218 32.9644C23.4491 32.6616 24.7685 32.7193 25.8716 32.64C28.7988 32.4309 29.2458 34.1252 29.1809 34.2478C29.116 34.3703 25.4174 34.7453 23.8817 34.7669V34.7597Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.073 32.986C18.8855 32.986 18.7269 34.3486 18.936 34.5145C19.1451 34.6803 21.0845 34.738 21.409 34.7596C21.7334 34.7812 22.0795 33.3032 22.3751 33.0941C22.6707 32.885 19.073 32.986 19.073 32.986Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5266 32.8706C17.4379 32.8274 19.089 31.3566 21.4899 31.3566C23.8907 31.3566 24.8496 32.0631 24.9145 32.3011C24.9722 32.539 21.3889 32.986 18.5338 32.8634L18.5266 32.8706Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1809 6.21584C11.4599 5.95628 11.8853 18.4365 19.1095 20.3687C26.3338 22.301 32.1954 10.7869 32.7073 8.44367C33.2192 6.10047 24.4737 8.20574 18.8284 7.31172C13.1831 6.42491 12.1737 6.20862 12.1737 6.20862L12.1809 6.21584Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M27.739 2.07745C23.341 2.45237 24.0404 5.1849 24.6821 5.6968C25.3237 6.20869 31.1276 5.05511 31.9856 3.88712C32.8435 2.71913 27.739 2.07745 27.739 2.07745Z",
    fill: "#FF450C"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7393 2.07745C25.9657 2.43074 28.0926 3.99528 28.965 3.95202C29.8374 3.90155 30.7674 2.68308 30.1113 2.53168C29.4552 2.38027 27.7393 2.08466 27.7393 2.08466V2.07745Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3696 5.94901C39.0452 6.26624 41.3019 7.23236 41.8931 10.2965C42.4843 13.3607 44.5751 10.7003 44.4742 8.44362C44.366 6.18694 41.6551 5.47316 39.3696 5.94901Z",
    fill: "#FF4D74"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0.544944 10.4048C0.667511 12.4163 2.11669 13.3536 2.39788 13.2959C2.67906 13.2382 2.15274 8.27065 5.62068 6.59076C7.09869 5.87698 1.58317 6.07886 1.07127 6.59076C0.559372 7.10265 0.429587 8.4509 0.544944 10.4048Z",
    fill: "#FF4D74"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3592 7.75884C13.1264 8.35005 14.5178 10.1381 15.109 10.0227C15.7003 9.90737 15.5921 7.16763 14.3592 7.75884Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7412 6.07159C11.7412 6.07159 23.4716 7.75149 31.3664 6.54745C31.3664 6.54745 20.3209 8.45084 11.7412 6.07159Z",
    fill: "#FFE861"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32.627 11.5656C32.6054 11.6809 32.5622 11.8035 32.5117 11.9261C32.0286 12.9715 30.3487 14.1395 29.4259 13.6492C29.1086 13.4834 28.9356 13.231 28.8707 12.921C28.64 11.8468 29.6782 10.102 30.3199 9.07819C31.149 7.75158 32.8289 10.4481 32.627 11.5656Z",
    fill: "#E56D8D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3004 14.7884C28.2571 15.1056 28.1634 15.4949 28.0264 15.9419C27.7164 16.9441 26.7214 16.2159 26.4475 15.4228C26.397 15.2858 26.3682 15.1561 26.3682 15.0263C26.3682 14.1395 27.2622 13.3608 28.0264 13.7574C28.286 13.8943 28.3653 14.2548 28.3004 14.7884Z",
    fill: "#E56D8D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M32.627 11.5656C32.6054 11.6809 32.5622 11.8035 32.5117 11.9261L32.4396 11.9405C32.4396 11.9405 32.5045 11.6233 32.2089 10.722C31.9133 9.8208 31.1346 8.78258 30.2766 9.54683C29.4331 10.3111 28.8924 12.8417 28.8707 12.921C28.64 11.8468 29.6782 10.102 30.3199 9.07819C31.149 7.75158 32.8289 10.4481 32.627 11.5656Z",
    fill: "#E56D8D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3004 14.7884C28.3004 14.7884 27.6732 13.6564 27.0603 13.9088C26.4475 14.1683 26.4475 15.4228 26.4475 15.4228C26.397 15.2858 26.3682 15.1561 26.3682 15.0263C26.3682 14.1395 27.2622 13.3608 28.0264 13.7574C28.286 13.8943 28.3653 14.2548 28.3004 14.7884Z",
    fill: "#E56D8D"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M33.623 11.8034C33.623 11.8034 35.0578 11.0969 35.786 9.89281C36.5142 8.68877 35.2885 5.61017 35.2885 5.61017L33.623 11.8106V11.8034Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2994 5.81212C10.2994 5.81212 10.0975 6.87917 9.85235 7.01616C9.60722 7.15315 8.6555 9.17911 9.13135 10.3399C9.6072 11.5007 11.5611 11.8828 11.5611 11.8828C11.5611 11.8828 10.5878 8.36439 10.2994 5.8049V5.81212Z",
    fill: "#DE5155"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31348 10.3398C3.52256 12.4162 4.17144 12.7262 4.61124 12.5676C5.05104 12.4162 4.39494 8.04706 6.5651 7.11699C6.5651 7.11699 3.4072 6.90069 3.31348 10.3398Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M38.873 7.25399C38.9307 7.51355 40.589 9.66208 40.5818 11.8034C40.5674 13.9519 41.9877 9.61881 40.8341 8.23452C39.6805 6.85023 38.8803 7.25399 38.8803 7.25399H38.873Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76218 15.0407C3.70233 14.8244 5.42548 17.4272 7.53076 17.5137C9.62882 17.6002 10.2849 17.5137 10.2849 17.5137C10.2849 17.5137 5.38223 15.1633 4.76218 15.0407Z",
    fill: "#FF450C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.017 16.7711C36.017 16.7711 39.694 16.7278 40.552 16.288C41.4099 15.8554 41.5037 14.1034 41.2802 14.0025C41.0639 13.8943 40.1987 14.8893 38.5332 15.6968C36.8677 16.5043 36.0098 16.7711 36.0098 16.7711H36.017Z",
    fill: "#FF450C"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1211 6.21589C36.5443 6.36009 36.7029 5.21372 38.4044 5.03348C39.8031 4.88928 40.3439 5.62468 40.3439 5.62468C40.3439 5.62468 39.6229 5.59584 37.1211 6.21589Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51165 5.84811C4.78345 5.37947 10.1548 5.55251 8.5542 6.58351C8.5542 6.58351 7.17712 6.07161 5.51165 5.84811Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0736 32.986C18.1291 32.8923 19.8018 31.8325 20.977 32.3083C22.1595 32.7842 21.2222 33.1951 19.0736 32.986Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2709 16.288C37.1412 16.4682 38.5831 16.4177 38.9292 15.7616C39.2753 15.1055 37.5377 15.9058 37.2709 16.288Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13138 16.8937C9.17463 17.1532 7.06936 16.7351 7.14867 16.2953C7.22798 15.8555 9.08091 16.562 9.13138 16.8937Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5711 19.4891C30.9626 18.3067 30.7463 22.2217 30.7463 22.2217C30.7463 22.2217 29.1241 20.8302 29.5711 19.4891Z",
    fill: "#E52F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7522 22.3732C13.6657 22.3876 13.6008 22.3876 13.5792 22.3876C13.4999 21.9478 14.3867 19.2513 15.2807 19.6839C15.4537 20.8879 14.3867 22.1929 13.7594 22.3732H13.7522Z",
    fill: "#E52F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5713 3.83665C13.6722 3.08683 17.5151 1.64486 19.8511 2.07745C22.1871 2.51004 24.3788 5.30025 24.2058 5.61748C24.0328 5.93472 14.7609 6.15822 13.5713 3.83665Z",
    fill: "#BE2F55"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9135 23.1373C24.0339 23.1877 22.9236 22.1711 23.6085 21.5727C24.7549 20.5778 28.6049 19.6189 29.946 18.3571L32.0945 16.3384C32.0945 16.3384 31.597 17.8164 29.8378 19.3233C28.0786 20.8229 25.3533 23.1228 24.9135 23.1445V23.1373Z",
    fill: "#DE5155"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1429 14.0744C28.2511 17.1891 25.843 19.8135 22.7644 19.8135C19.6858 19.8135 17.2704 17.1891 17.3858 14.0744C17.4939 11.0824 19.9021 8.73917 22.7644 8.73917C25.6267 8.73917 28.042 11.0824 28.1429 14.0744Z",
    fill: "url(#paint9_linear_2390_49698)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8395 16.0357C18.337 14.0458 27.4646 12.6687 27.9405 13.1806C28.4235 13.6997 27.3709 19.2801 22.9296 19.3378C18.4884 19.3883 17.7025 16.5837 17.8395 16.0429V16.0357Z",
    fill: "white"
  }))), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5903 15.2663C24.9666 15.2663 25.2465 15.3264 25.4299 15.4466C25.6133 15.5667 25.705 15.7486 25.705 15.9921C25.705 16.2387 25.6133 16.4221 25.4299 16.5423C25.2465 16.6625 24.9666 16.7225 24.5903 16.7225H21.8012C21.4818 16.7225 21.2447 16.6625 21.0897 16.5423C20.9348 16.4221 20.8573 16.2387 20.8573 15.9921C20.8573 15.7707 21.1751 15.3138 21.8107 14.6212C21.9404 14.4821 22.04 14.373 22.1095 14.2939C22.8084 13.5255 23.2748 12.9658 23.5088 12.6148C23.7428 12.2606 23.8598 11.9713 23.8598 11.7467C23.8598 11.5538 23.8029 11.3957 23.6891 11.2724C23.5784 11.1491 23.4377 11.0874 23.2669 11.0874C23.1088 11.0874 22.9649 11.1491 22.8353 11.2724C22.7088 11.3926 22.6028 11.5681 22.5175 11.7989C22.4036 12.1183 22.2914 12.3318 22.1807 12.4393C22.0732 12.5436 21.9309 12.5958 21.7538 12.5958C21.5229 12.5958 21.3348 12.5215 21.1893 12.3729C21.047 12.2242 20.9759 12.0298 20.9759 11.7894C20.9759 11.5934 21.0201 11.3783 21.1087 11.1443C21.1972 10.9072 21.3142 10.6969 21.4597 10.5135C21.6937 10.2257 21.9688 10.0059 22.285 9.85414C22.6013 9.6992 22.9444 9.62172 23.3143 9.62172C23.9689 9.62172 24.5018 9.81462 24.9129 10.2004C25.3239 10.583 25.5295 11.0732 25.5295 11.6709C25.5295 12.1199 25.373 12.5911 25.0599 13.0844C24.75 13.5777 24.1096 14.305 23.1388 15.2663H24.5903Z",
    fill: "#FFE228"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4371 13.8184C23.6983 13.8184 23.8926 13.8601 24.0199 13.9436C24.1473 14.027 24.2109 14.1532 24.2109 14.3222C24.2109 14.4935 24.1473 14.6208 24.0199 14.7042C23.8926 14.7876 23.6983 14.8293 23.4371 14.8293H21.5009C21.2792 14.8293 21.1146 14.7876 21.007 14.7042C20.8995 14.6208 20.8457 14.4935 20.8457 14.3222C20.8457 14.1686 21.0663 13.8514 21.5075 13.3706C21.5975 13.274 21.6667 13.1983 21.715 13.1434C22.2001 12.61 22.5239 12.2214 22.6864 11.9778C22.8488 11.7319 22.93 11.531 22.93 11.3752C22.93 11.2413 22.8905 11.1315 22.8115 11.0459C22.7346 10.9603 22.637 10.9175 22.5184 10.9175C22.4087 10.9175 22.3088 10.9603 22.2188 11.0459C22.131 11.1293 22.0574 11.2511 21.9982 11.4114C21.9191 11.6331 21.8412 11.7813 21.7644 11.8559C21.6897 11.9284 21.5909 11.9646 21.468 11.9646C21.3078 11.9646 21.1772 11.913 21.0762 11.8098C20.9774 11.7066 20.928 11.5716 20.928 11.4048C20.928 11.2687 20.9587 11.1194 21.0202 10.957C21.0817 10.7923 21.1629 10.6464 21.2639 10.519C21.4263 10.3193 21.6173 10.1667 21.8368 10.0613C22.0563 9.95378 22.2945 9.9 22.5513 9.9C23.0058 9.9 23.3756 10.0339 23.661 10.3017C23.9464 10.5673 24.0891 10.9076 24.0891 11.3225C24.0891 11.6342 23.9804 11.9613 23.7631 12.3037C23.548 12.6462 23.1034 13.1511 22.4295 13.8184H23.4371Z",
    fill: "#FFA400"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3789 14.0746C17.3789 14.0746 18.5829 9.39544 22.9304 9.39544C27.0473 9.39544 28.0422 13.022 28.0422 13.022C28.0422 13.022 27.314 8.61679 22.6276 8.73936C17.934 8.86193 17.3789 13.5699 17.3789 14.0746Z",
    fill: "#BE2F55"
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M18.165 17.1604C18.165 17.1604 19.744 19.9578 23.1038 19.8064C26.4636 19.655 27.7613 16.3169 27.7613 16.3169C27.7613 16.3169 26.1896 20.3255 22.9307 20.3327C19.6719 20.34 18.165 17.1604 18.165 17.1604Z",
    fill: "url(#paint10_linear_2390_49698)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2390_49698",
    x1: 29.4339,
    y1: 13.2959,
    x2: 43.5869,
    y2: 13.2959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2390_49698",
    x1: 15.4043,
    y1: -111.759,
    x2: 1.25135,
    y2: -111.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FA9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F63F00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2390_49698",
    x1: 37.1193,
    y1: 22.3946,
    x2: 37.1193,
    y2: 5.61008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2390_49698",
    x1: 7.68223,
    y1: 22.3875,
    x2: 7.68223,
    y2: 5.61019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2390_49698",
    x1: 1.30859,
    y1: 6.07164,
    x2: 10.566,
    y2: 6.07164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE834"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2390_49698",
    x1: 34.6543,
    y1: 5.7039,
    x2: 43.0898,
    y2: 5.7039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2390_49698",
    x1: 10.1625,
    y1: 19.792,
    x2: 35.4907,
    y2: 19.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2390_49698",
    x1: 10.0973,
    y1: 3.93749,
    x2: 35.4904,
    y2: 3.93749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2390_49698",
    x1: 15.0793,
    y1: 3.99731,
    x2: 34.1072,
    y2: 3.37939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F63F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F66A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2390_49698",
    x1: 22.7644,
    y1: 20.2475,
    x2: 22.7644,
    y2: 9.13167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#EF6300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E13E00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2390_49698",
    x1: 18.165,
    y1: 18.3284,
    x2: 27.7685,
    y2: 18.3284,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE834"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinWinnerTrophy2);
export default __webpack_public_path__ + "static/media/spin-winner-trophy2.26e7295d557504d05f7887b0c5c8d170.svg";
export { ForwardRef as ReactComponent };